var map = {
	"./angle-down.svg": "./src/img/angle-down.svg",
	"./arrow-right-green.svg": "./src/img/arrow-right-green.svg",
	"./footer-icon.svg": "./src/img/footer-icon.svg",
	"./gf-error-icon.svg": "./src/img/gf-error-icon.svg",
	"./icon-checks.svg": "./src/img/icon-checks.svg",
	"./icon-strl-blue.svg": "./src/img/icon-strl-blue.svg",
	"./icon-strl-white.svg": "./src/img/icon-strl-white.svg",
	"./location-crosshairs.svg": "./src/img/location-crosshairs.svg",
	"./location-dot.png": "./src/img/location-dot.png",
	"./logo-hartekamp.png": "./src/img/logo-hartekamp.png",
	"./logo.svg": "./src/img/logo.svg",
	"./strl-16px.png": "./src/img/strl-16px.png",
	"./strl-36px.png": "./src/img/strl-36px.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/img sync recursive ^\\.\\/.*$";